import { render, staticRenderFns } from "./Segmented.vue?vue&type=template&id=91c2fb68&scoped=true"
import script from "./Segmented.vue?vue&type=script&lang=js"
export * from "./Segmented.vue?vue&type=script&lang=js"
import style0 from "./Segmented.vue?vue&type=style&index=0&id=91c2fb68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c2fb68",
  null
  
)

export default component.exports